<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="off">
      <h3 class="title">系统登录</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" placeholder="用户名" prefix-icon="el-icon-user" />
      </el-form-item>

      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" placeholder="密码" prefix-icon="el-icon-lock"
          @keyup.enter.native="handleLogin" />
      </el-form-item>

      <el-button :loading="loading" type="primary" style="width:100%" @click.native.prevent="handleLogin">
        登录
      </el-button>
    </el-form>
  </div>
</template>

<script>
  import { getUserInfo } from "@/api/rbac/user";
  export default {
    name: 'BackLogin',
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loginRules: {
          username: [
            { required: true, trigger: 'blur', message: '请输入用户名' },
            { min: 3, max: 20, message: '长度在3到20个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, trigger: 'blur', message: '请输入密码' },
            { min: 6, max: 20, message: '长度在6到20个字符', trigger: 'blur' }
          ]
        },
        loading: false
      }
    },
    methods: {
      handleLogin() {
        try {
          getUserInfo({ strWhere: ` and a.iscus=0 and a.name='${this.loginForm.username}' and a.psw='${this.loginForm.password}'` }).then((res) => {
            if (res.data.length == 0) {
              alert("用户名或密码不正确!");
            }
            else {
              const user = { id: res.data[0].id, name: this.loginForm.username, psw: this.loginForm.password, intlevel: res.data[0].intLevel, intMonth: res.data[0].intMonth }; // 示例用户信息，实际应用中应从表单获取或API响应中获取

              // localStorage.removeItem('token');

              localStorage.setItem("token", JSON.stringify(user));
              setTimeout(() => {
                  this.$router.push('/BackIndex', () => { }, () => { });
              }, 1000)
              // this.$router.push('/',()=>{},()=>{});
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
    },
    mounted() {
      localStorage.clear();
    },
  }
</script>

<style scoped>
  .login-container {
    height: 100vh;
    background: #2d3a4b;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-form {
    width: 400px;
    padding: 35px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .title {
    margin: 0 auto 30px;
    text-align: center;
    color: #333;
  }
</style>